import React from 'react';
import { LockIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
type SectionCtaProps = {
  label: string;
  tone?: 'light' | 'dark';
};
export function SectionCta({
  label,
  tone = 'light'
}: SectionCtaProps) {
  return <div className="mx-auto mt-12 w-full max-w-xl" data-id="element-42" data-mp="3id6xf85hr2aw">
      <CtaButton label={label} size="md" data-id="element-43" data-mp="3nc0ax0ks2tb2" />
      <p className={`mt-3 flex items-center justify-center gap-1.5 text-center text-sm ${tone === 'dark' ? 'text-white/70' : 'text-muted'}`} data-id="element-44" data-mp="3nayra7pp4yhq">
        <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-45" data-mp="3de3sdnpigw2x" />
        One-time payment of $27 · Instant access · 7-day guarantee
      </p>
    </div>;
}